import { render, staticRenderFns } from "./DetailExtraPanel.vue?vue&type=template&id=39829b32&scoped=true"
import script from "./DetailExtraPanel.vue?vue&type=script&lang=js"
export * from "./DetailExtraPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailExtraPanel.vue?vue&type=style&index=0&id=39829b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39829b32",
  null
  
)

export default component.exports